import OnboardingLayout from '@layout/onboarding-layout';
import KycFooter from '@pages/kyc/components/kyc-footer';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import CreateProviderOnboarding from './create-provider-onboarding';
import ProviderStatus from './provider-status';

const ProviderOnboarding: React.FunctionComponent = () => {
  return (
    <OnboardingLayout footer={<KycFooter />}>
      <Switch>
        <Route exact path={'/'} component={ProviderStatus} />
        <Route exact path={'/create-provider'} component={CreateProviderOnboarding} />
        <Redirect to="/" />
      </Switch>
    </OnboardingLayout>
  );
};

export default ProviderOnboarding;
